import React, { useState, useEffect } from 'react';
import { firestore, collection, query,  doc, deleteDoc,  addDoc, where, getDocs, updateDoc,setDoc } from "../firebase"; 
import { useNavigate } from 'react-router-dom';
import MemberDrawer from './MemberDrawer.js';
import AddItemPopup from './AddItemPopup.js';
import ItemDrawer from './ItemDrawer.js';

import { fetchPendingRequests, fetchInitialItems, fetchMoreItems } from './membershipApi.js';

import {
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Fab,
  TextField,
  Snackbar,
  Alert,
  Typography
} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import AddIcon from '@mui/icons-material/Add';
import ShareIcon from '@mui/icons-material/Share';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import * as Papa from "papaparse";

const MembershipMgmt= ({ isAdmin }) => {
  const [data, setData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  const [openConfirmDeleteItem, setOpenConfirmDeleteItem] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [openAddPopup, setOpenAddPopup] = useState(false); // State for AddItemPopup
  const [filteredData, setFilteredData] = useState([]); // For filtered items
const [searchQuery, setSearchQuery] = useState("");
const [popupOpen, setPopupOpen] = useState(false);
const [requests, setRequests] = useState([]);
const [statusMessage, setStatusMessage] = useState(""); // Track status messages
const [openSnackbar, setOpenSnackbar] = useState(false);
const [selectedreq, setSelectedReq] = useState(null);
const [snackbarSeverity, setSnackbarSeverity] = useState("success")
const [dialogOpen, setDialogOpen] = useState(false);
const [visibleItems, setVisibleItems] = useState(10);
const [loadingMore, setLoadingMore] = useState(false);
const [lastVisible, setLastVisible] = useState(null);
const [duplicateEntries, setDuplicateEntries] = useState([]);
const [currentTenantId, setCurrentTenantId] = useState(null);


const navigate = useNavigate();

useEffect(() => {
  // Get current tenant context from sessionStorage
  const tenantId = sessionStorage.getItem("tenantId");
  if (tenantId) {
    setCurrentTenantId(tenantId);
  }
}, []);

useEffect(() => {
  const unsubscribe = fetchPendingRequests(setRequests, currentTenantId);

  // Cleanup on unmount
  return () => unsubscribe();
}, [currentTenantId]);

useEffect(() => {
  const unsubscribe = fetchInitialItems(setData, setFilteredData, setLoadingMore, setLastVisible, currentTenantId);

  // Cleanup the listener on component unmount
  return () => unsubscribe();
}, [currentTenantId]);

// Fetch more items when user requests (e.g., scrolls down)
const handleFetchMore = () => {
  fetchMoreItems(setData, setLastVisible, setLoadingMore, loadingMore, lastVisible, setFilteredData, currentTenantId);
};


const showStatusMessage = (message, severity = "success") => {
  setStatusMessage(message);
  setSnackbarSeverity(severity);
  setOpenSnackbar(true);
  setTimeout(() => setOpenSnackbar(false), 3000);
};


const handleReqOpenDrawer = (id) => {
  const member = requests.find(member => member.id === id);
  setSelectedReq(member);
  setDialogOpen(true);
};

const handleReqCloseDrawer = () => {
  setSelectedReq(null);
  setDialogOpen(false);
};

const handleApprove = async (request) => {
  try {
    console.log("Approval Process: Starting approval for request:", request.id);
    console.log("Approval Process: Request data:", request);
    
    if (!request.personalEmail) {
      showStatusMessage("Error: Email address is missing.", "error");
      return;
    }

    // Check for duplicates
    const duplicates = await checkForDuplicates(request);
    if (duplicates.length > 0) {
      const duplicateMessage = duplicates.map(d => 
        `${d.field}: ${d.value} (Existing member: ${d.existingMember.firstName} ${d.existingMember.surname})`
      ).join('\n');
      
      showStatusMessage(
        `Warning: This member has potential duplicates:\n${duplicateMessage}\nPlease verify before approving.`,
        "warning"
      );
      return;
    }

    // Check if the email already exists in MembershipMaster
    const membersRef = collection(firestore, "MembershipMaster");
    const emailQuery = query(membersRef, where("personalEmail", "==", request.personalEmail));
    const emailSnapshot = await getDocs(emailQuery);
    
    console.log("Approval Process: Existing members with this email:", emailSnapshot.size);

    if (!emailSnapshot.empty) {
      // Email exists, so update the existing document
      const existingDoc = emailSnapshot.docs[0];
      const memberRef = doc(firestore, "MembershipMaster", existingDoc.id);
      
      console.log("Approval Process: Updating existing member:", existingDoc.id);

      await updateDoc(memberRef, {
        ...request,
        status: "approved",
        memberId: existingDoc.id,
        approvalDate: new Date().toISOString(),
        tenantId: request.tenantId // Preserve tenant context
      });
      
      console.log("Approval Process: Successfully updated existing member");
    } else {
      // Email doesn't exist, so create a new document
      const memberRef = doc(firestore, "MembershipMaster", request.id);
      
      console.log("Approval Process: Creating new member with ID:", request.id);
      console.log("Approval Process: Member data to save:", {
        ...request,
        status: "approved",
        memberId: request.id,
        approvalDate: new Date().toISOString(),
        tenantId: request.tenantId
      });
      
      await setDoc(memberRef, {
        ...request,
        status: "approved",
        memberId: request.id,
        approvalDate: new Date().toISOString(),
        tenantId: request.tenantId // Preserve tenant context
      });
      
      console.log("Approval Process: Successfully created new member");
    }

    // Delete the document from MembershipRequests
    const requestRef = doc(firestore, "MembershipRequests", request.id);
    await deleteDoc(requestRef);
    
    console.log("Approval Process: Deleted request from MembershipRequests");

    handleCloseDrawer();
    showStatusMessage("Member approved and added!", "success");
    console.log("Approval Process: Approval process completed successfully");
  } catch (error) {
    console.error("Error approving request:", error);
    showStatusMessage("Error approving member.", "error");
  }
};

const handleDeny = async (request) => {
  try {
    const requestRef = doc(firestore, "MembershipRequests", request.id);
    const rejectedRef = doc(firestore, "RejectedMemberships", request.id);
    
    // Move the request to RejectedMemberships collection
    await setDoc(rejectedRef, {
      ...request,
      status: "rejected",
      rejectedDate: new Date().toISOString()
    });
    
    // Delete from MembershipRequests
    await deleteDoc(requestRef);

    handleCloseDrawer();
    showStatusMessage("Member request denied.","error");
  } catch (error) {
    console.error("Error denying request:", error);
    showStatusMessage("Error denying member.","error");
  }
};

  {/*useEffect(() => {
    // Create a reference to the MembershipMaster collection
    const membershipCollectionRef = collection(firestore, "MembershipMaster");

    // Subscribe to real-time updates from the collection
    const unsubscribe = onSnapshot(membershipCollectionRef, (snapshot) => {
        // Map through the snapshot docs to get the data without any transformations
        const newData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data()
        }));

        // Update the state with the new data
        setData(newData);
        setFilteredData(newData); // Initialize filtered data with all items
    });

    // Cleanup subscription on unmount
    return () => unsubscribe();
}, []);*/}


  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
  
    const filtered = data.filter(
      item =>
        (item.firstName?.toLowerCase() || '').includes(query) ||
        (item.surname?.toLowerCase() || '').includes(query)
    );
    setFilteredData(filtered);
  };


  const handleOpenDrawer = (id) => {
    const item = data.find(item => item.id === id);
    setSelectedItem(item);
  };

  const handleCloseDrawer = () => {
    setSelectedItem(null);
  };

  const handleDeleteSelected = () => {
    if (selectedRows.length === 0) return;
    setOpenConfirmDelete(true);
  };

  const checkForDuplicates = async (memberData, excludeId = null) => {
    try {
      const membersRef = collection(firestore, "MembershipMaster");
      const emailQuery = query(membersRef, where("personalEmail", "==", memberData.personalEmail));
      const mobileQuery = query(membersRef, where("mobileNo", "==", memberData.mobileNo));
      
      const [emailSnapshot, mobileSnapshot] = await Promise.all([
        getDocs(emailQuery),
        getDocs(mobileQuery)
      ]);

      const duplicates = [];
      
      // Check email duplicates
      emailSnapshot.forEach(doc => {
        if (doc.id !== excludeId && doc.data().personalEmail === memberData.personalEmail) {
          duplicates.push({
            id: doc.id,  // Make sure to include the document ID
            field: 'Email',
            value: memberData.personalEmail,
            existingMember: { id: doc.id, ...doc.data() }
          });
        }
      });
      
      // Check mobile duplicates
      mobileSnapshot.forEach(doc => {
        if (doc.id !== excludeId && doc.data().mobileNo === memberData.mobileNo) {
          // Only add if not already added through email check
          if (!duplicates.some(d => d.id === doc.id)) {
            duplicates.push({
              id: doc.id,  // Make sure to include the document ID
              field: 'Mobile',
              value: memberData.mobileNo,
              existingMember: { id: doc.id, ...doc.data() }
            });
          }
        }
      });

      return duplicates;
    } catch (error) {
      console.error("Error checking for duplicates:", error);
      return [];
    }
  };

  const confirmDeleteItem = async () => {
    if (itemToDelete) {
      try {
        // First check for duplicates
        const memberToDelete = data.find(member => member.id === itemToDelete);
        if (memberToDelete) {
          const duplicates = await checkForDuplicates(memberToDelete, itemToDelete);
          
          if (duplicates.length > 0) {
            const duplicateMessage = duplicates.map(d => 
              `${d.field}: ${d.value} (Existing member: ${d.existingMember.firstName} ${d.existingMember.surname})`
            ).join('\n');
            
            // Show warning but allow deletion
            showStatusMessage(
              `Warning: There are other members with the same email/mobile. Proceeding with deletion.`,
              "warning"
            );
          }
        }

        // Proceed with deletion
        const docRef = doc(firestore, 'MembershipMaster', itemToDelete);
        await deleteDoc(docRef);
        
        // Update local state
        setData(prevData => prevData.filter(item => item.id !== itemToDelete));
        setFilteredData(prevData => prevData.filter(item => item.id !== itemToDelete));
        
        showStatusMessage("Member deleted successfully", "success");
        
        setItemToDelete(null);
        setOpenConfirmDeleteItem(false);
      } catch (error) {
        console.error(`Error deleting document with id ${itemToDelete}: `, error);
        showStatusMessage("Error deleting member", "error");
      }
    }
  };
  
  const confirmDeleteSelected = async () => {
    try {
      // Delete documents directly using their IDs
      const deletePromises = selectedRows.map(async (id) => {
        const docRef = doc(firestore, 'MembershipMaster', id);
        await deleteDoc(docRef);
      });

      await Promise.all(deletePromises);
      console.log(`Deleted documents with ids: ${selectedRows.join(", ")}`);

      // Update local state to remove deleted items
      setData(prevData => prevData.filter(item => !selectedRows.includes(item.id)));
      setFilteredData(prevData => prevData.filter(item => !selectedRows.includes(item.id)));

      // Show success message
      showStatusMessage("Selected members deleted successfully", "success");

      // Clear selected rows
      setSelectedRows([]);
      setSelectAll(false);
      setOpenConfirmDelete(false);
    } catch (error) {
      console.error('Error deleting selected documents: ', error);
      showStatusMessage("Error deleting selected members", "error");
    }
  };

  const cancelDeleteSelected = () => {
    setOpenConfirmDelete(false);
  };

  const handleDelete = async (id) => {
    const memberToDelete = data.find(member => member.id === id);
    if (memberToDelete) {
      const duplicates = await checkForDuplicates(memberToDelete, id);
      // Include the current member in duplicateEntries with its ID
      setDuplicateEntries([{ id, field: 'Current', ...memberToDelete }, ...duplicates]);
    }
    setItemToDelete(id);
    setOpenConfirmDeleteItem(true);
  };

  const deleteSingleEntry = async () => {
    try {
      const docRef = doc(firestore, 'MembershipMaster', itemToDelete);
      await deleteDoc(docRef);
      
      // Update local state
      setData(prevData => prevData.filter(item => item.id !== itemToDelete));
      setFilteredData(prevData => prevData.filter(item => item.id !== itemToDelete));
      
      showStatusMessage("Member deleted successfully", "success");
      
      setItemToDelete(null);
      setDuplicateEntries([]);
      setOpenConfirmDeleteItem(false);
    } catch (error) {
      console.error(`Error deleting document with id ${itemToDelete}: `, error);
      showStatusMessage("Error deleting member", "error");
    }
  };

  const deleteAllDuplicates = async () => {
    try {
      if (duplicateEntries.length === 0) {
        showStatusMessage("No entries to delete", "error");
        return;
      }

      // Get all unique IDs to delete
      const idsToDelete = [...new Set(duplicateEntries.map(entry => entry.id))];
      
      console.log("Deleting entries with IDs:", idsToDelete); // For debugging

      // Delete all entries
      const deletePromises = idsToDelete.map(id => {
        if (!id) {
          console.error("Invalid ID found in duplicateEntries");
          return Promise.resolve();
        }
        const docRef = doc(firestore, 'MembershipMaster', id);
        return deleteDoc(docRef);
      });

      await Promise.all(deletePromises.filter(Boolean));
      
      // Update local state
      setData(prevData => prevData.filter(item => !idsToDelete.includes(item.id)));
      setFilteredData(prevData => prevData.filter(item => !idsToDelete.includes(item.id)));
      
      showStatusMessage(`Successfully deleted ${idsToDelete.length} members`, "success");
      
      setItemToDelete(null);
      setDuplicateEntries([]);
      setOpenConfirmDeleteItem(false);
    } catch (error) {
      console.error('Error deleting duplicate members:', error);
      showStatusMessage(`Error deleting members: ${error.message}`, "error");
    }
  };

  const cancelDeleteItem = () => {
    setOpenConfirmDeleteItem(false);
    setItemToDelete(null);
  };
  
  const handleEdit = (id) => {
    navigate(`/membership/edit/${id}`);
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedRows(data.map(item => item.id));
    } else {
      setSelectedRows([]);
    }

    
    setSelectAll(event.target.checked);
  };

  const handleCopyLink = () => {
    const tenantId = sessionStorage.getItem("tenantId");
    const tenantName = sessionStorage.getItem("tenantName");
    
    // Generate compact unique link for each tenant
    const link = tenantId && tenantName
      ? `${window.location.origin}/membership-form?t=${tenantId}&n=${encodeURIComponent(tenantName.substring(0, 3))}`
      : `${window.location.origin}/membership-form`;
    
    navigator.clipboard.writeText(link)
      .then(() => {
        alert("Tenant-specific link copied to clipboard!");
      })
      .catch(err => console.error("Failed to copy link: ", err));
  };

  const handleAddMember = () => {
    navigate('/membership-form');
};

const handleAdd = async (newMember) => {
  try {
    await addDoc(collection(firestore, 'MembershipMaster'), { ...newMember});
    console.log('Document added');
  } catch (error) {
    console.error("Error adding document: ", error);
  }
};

const handleDownloadCSV = () => {
  if (selectedRows.length === 0) {
    alert("No members selected!");
    return;
  }

  // Filter selected members
  const selectedData = data.filter(member => selectedRows.includes(member.id));

  // Prepare data for CSV
  const csvData = selectedData.map(member => ({
    Name: member.firstName + " " + member.surname,
Email: member.personalEmail,
Category: member.membershipCategory,
MembershipStartDate: member.membershipStartDate,
MembershipEndDate: member.membershipEndDate,
City: member.city,
Expertise: member.expertise,
MobileNo: member.mobileNo,
ProfessionalEmail: member.professionalEmail,
DOB: member.dob,
ResiAddress: member.resiAddress1 + " " + member.resiAddress2,
Qualification: member.qualification,
Organisation: member.organisation,
NoOfEmployees: member.noOfEmployees,
Designation: member.designation,
Experience: member.experience,
PaymentRef: member.paymentRef,
LinkedIn: member.linkedIn,
Facebook: member.facebook,
Instagram: member.instagram,
ReferralSource: member.referralSource,
AdditionalComments: member.additionalComments
  }));

  // Convert data to CSV using PapaParse
  const csv = Papa.unparse(csvData);

  // Create a blob for downloading
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  // Create a link and trigger download
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "selected_members.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', boxSizing: 'border-box',  padding: '20px 20px 0' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px', paddingLeft: '20px' }}>
        <TextField
          label="Search by Member ID or Name"
          variant="outlined"
          value={searchQuery}
          onChange={handleSearch}
          style={{ width: '300px', marginRight: '16px' }}
        />
        <div style={{ display: 'flex', gap: '10px' }}>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleDeleteSelected}
            disabled={selectedRows.length === 0}
            style={{ padding: '4px 8px', fontSize: '0.75rem' }}
            startIcon={<DeleteIcon />}
          >
            Delete Selected ({selectedRows.length})
          </Button>

          <Button
            variant="contained"
            color="primary"
            onClick={handleDownloadCSV}
            disabled={selectedRows.length === 0}
          >
            Download Selected as CSV
          </Button>
        </div>
      </div>

      <TableContainer component={Paper} style={{ flexGrow: 1, paddingBottom: 40 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ textAlign: 'center', border: '1px solid #ddd', borderBottom: '1px solid black' }}>
                <Checkbox
                  checked={selectAll}
                  onChange={handleSelectAll}
                  style={{ margin: '0 auto' }}
                />
              </TableCell>
              <TableCell style={{ textAlign: 'center', border: '1px solid #ddd', borderBottom: '1px solid black' }}>Photo</TableCell>
              <TableCell style={{ textAlign: 'center', border: '1px solid #ddd', borderBottom: '1px solid black' }}>Name</TableCell>
              <TableCell style={{ textAlign: 'center', border: '1px solid #ddd', borderBottom: '1px solid black' }}>Email Address</TableCell>
              <TableCell style={{ textAlign: 'center', border: '1px solid #ddd', borderBottom: '1px solid black' }}>Membership Category</TableCell>
              <TableCell style={{ textAlign: 'center', border: '1px solid #ddd', borderBottom: '1px solid black' }}>Expertise</TableCell>
              <TableCell style={{ textAlign: 'center', border: '1px solid #ddd', borderBottom: '1px solid black' }}>More Details</TableCell>
              <TableCell style={{ textAlign: 'center', border: '1px solid #ddd', borderBottom: '1px solid black' }}>Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {/* Render request entries at the top */}
            {requests.map((request) => (
              <TableRow key={request.id}>
                <TableCell style={{ textAlign: 'center', borderRight: '1px solid #ddd' }}>
                  <Checkbox disabled style={{ margin: '0 auto' }} />
                </TableCell>
                <TableCell style={{ textAlign: 'center', borderRight: '1px solid #ddd' }}>
                  {request.photoURL ? (
                    <img 
                      src={request.photoURL} 
                      alt={`${request.firstName} ${request.surname}`} 
                      style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' }} 
                    />
                  ) : (
                    <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Typography variant="caption" color="textSecondary">No Photo</Typography>
                    </div>
                  )}
                </TableCell>
                <TableCell style={{ textAlign: 'center', borderRight: '1px solid #ddd' }}>{request.firstName} {request.surname}</TableCell>
                <TableCell style={{ textAlign: 'center', borderRight: '1px solid #ddd' }}>{request.personalEmail}</TableCell>
                <TableCell style={{ textAlign: 'center', borderRight: '1px solid #ddd' }}>{request.membershipCategory}</TableCell>
                <TableCell style={{ textAlign: 'center', borderRight: '1px solid #ddd' }}>{request.expertise}</TableCell>
                <TableCell style={{ textAlign: 'center', borderRight: '1px solid #ddd' }}>
                  <Tooltip title="More Details">
                    <IconButton onClick={() => handleReqOpenDrawer(request.id)}>
                      <UnfoldMoreIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
                <TableCell style={{ textAlign: 'center', borderRight: '1px solid #ddd' }}>
                  <Tooltip title="Approve">
                    <IconButton onClick={() => handleApprove(request)} aria-label="approve">
                      <CheckIcon sx={{ color: 'green' }} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Deny">
                    <IconButton onClick={() => handleDeny(request)} aria-label="deny">
                      <ClearIcon sx={{ color: 'red' }} />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}

            {/* Render non-request entries below */}
            {filteredData.map((row) => (
              <TableRow key={row.id}>
                <TableCell style={{ textAlign: 'center', borderRight: '1px solid #ddd' }}>
                  <Checkbox
                    checked={selectedRows.includes(row.id)}
                    onChange={() => {
                      const newSelectedRows = selectedRows.includes(row.id)
                        ? selectedRows.filter(id => id !== row.id)
                        : [...selectedRows, row.id];
                      setSelectedRows(newSelectedRows);
                    }}
                  />
                </TableCell>
                <TableCell style={{ textAlign: 'center', borderRight: '1px solid #ddd' }}>
                  {row.photoURL ? (
                    <img 
                      src={row.photoURL} 
                      alt={`${row.firstName} ${row.surname}`} 
                      style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover' }} 
                    />
                  ) : (
                    <div style={{ width: '40px', height: '40px', borderRadius: '50%', backgroundColor: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Typography variant="caption" color="textSecondary">No Photo</Typography>
                    </div>
                  )}
                </TableCell>
                <TableCell style={{ textAlign: 'center', borderRight: '1px solid #ddd' }}>{row.firstName} {row.surname}</TableCell>
                <TableCell style={{ textAlign: 'center', borderRight: '1px solid #ddd' }}>{row.personalEmail}</TableCell>
                <TableCell style={{ textAlign: 'center', borderRight: '1px solid #ddd' }}>{row.membershipCategory}</TableCell>
                <TableCell style={{ textAlign: 'center', borderRight: '1px solid #ddd' }}>{row.expertise}</TableCell>
                <TableCell style={{ textAlign: 'center', borderRight: '1px solid #ddd' }}>
                  <Tooltip title="More Details">
                    <IconButton onClick={() => handleOpenDrawer(row.id)}>
                      <UnfoldMoreIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
                <TableCell style={{ textAlign: 'center', borderRight: '1px solid #ddd' }}>
                  <Tooltip title="Delete">
                    <IconButton onClick={() => handleDelete(row.id)} aria-label="delete">
                      <DeleteIcon sx={{ color: '#948a1e' }} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Edit">
                    <IconButton onClick={() => handleEdit(row.id)} aria-label="edit">
                      <EditIcon sx={{ color: '#1976d2' }} />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {lastVisible && (
          <Button
            variant="contained"
            onClick={handleFetchMore} disabled={loadingMore || !lastVisible}
            sx={{
              display: 'block',
              margin: '20px auto',
              padding: '12px 24px',
              fontSize: '1rem',
              backgroundColor: '#1976d2',
              color: '#fff',
              '&:hover': {
                backgroundColor: '#115293',
              },
              '&:disabled': {
                backgroundColor: '#E8E8E8',
                color: '#aaa',
              },
            }}
          >
            {loadingMore ? (
              <span style={{ display: 'flex', alignItems: 'center' }}>
                <span className="loading-spinner" style={{ marginRight: '8px', width: '20px', height: '20px' }}>
                  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#fff">
                    <circle cx="12" cy="12" r="10" stroke="rgba(255, 255, 255, 0.5)" strokeWidth="4" fill="none" />
                    <path d="M12 2 a10 10 0 0 1 10 10" stroke="#fff" strokeWidth="4" strokeLinecap="round" fill="none" />
                  </svg>
                </span>
                Loading...
              </span>
            ) : (
              'Load More'
            )}
          </Button>
        )}
      </TableContainer>

      <Dialog open={openConfirmDelete} onClose={cancelDeleteSelected}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          Are you sure you want to delete the selected items?
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelDeleteSelected} color="primary">Cancel</Button>
          <Button onClick={confirmDeleteSelected} color="primary">Confirm</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openConfirmDeleteItem} onClose={cancelDeleteItem}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          {duplicateEntries.length > 1 ? (
            <>
              <p>Warning: This member has {duplicateEntries.length - 1} duplicate entries with the same email or mobile number.</p>
              <p>Duplicate entries found:</p>
              <ul>
                {duplicateEntries.map((entry, index) => (
                  <li key={index}>
                    {entry.firstName} {entry.surname} ({entry.personalEmail || entry.mobileNo})
                  </li>
                ))}
              </ul>
              <p>Would you like to delete just this entry or all duplicate entries?</p>
            </>
          ) : (
            <p>Are you sure you want to delete this item?</p>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelDeleteItem} color="primary">Cancel</Button>
          {duplicateEntries.length > 1 ? (
            <>
              <Button onClick={deleteSingleEntry} color="primary">Delete Single Entry</Button>
              <Button onClick={deleteAllDuplicates} color="error">Delete All Duplicates</Button>
            </>
          ) : (
            <Button onClick={deleteSingleEntry} color="primary">Confirm</Button>
          )}
        </DialogActions>
      </Dialog>

      <MemberDrawer
      open={Boolean(selectedItem)}
        member={selectedItem}
        onClose={handleCloseDrawer}
      />

<ItemDrawer
  open={!!selectedreq}
  onClose={handleReqCloseDrawer}
  member={selectedreq}
  approve={handleApprove}
  deny={handleDeny}
/>

<Snackbar
  open={openSnackbar}
  autoHideDuration={3000}
  anchorOrigin={{ vertical: "top", horizontal: "right" }}
  onClose={() => setOpenSnackbar(false)}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity}>
    {statusMessage}
  </Alert>
</Snackbar>

<Fab 
  color="secondary" 
  onClick={handleCopyLink} 
  style={{ position: 'fixed', bottom: 60, right: 20 }}
>
  <Tooltip title="Copy Membership form Link">
    <ShareIcon />
  </Tooltip>
</Fab>

<Fab
          onClick={() => setPopupOpen(true)}
          style={{
            position: 'fixed', bottom: 60, right: 100,
            backgroundColor: '#1976d2',
            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',

            transition: 'background-color 0.3s ease',
          }}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#145ea8'}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#1976d2'}
          aria-label="Add new item"
        >
          <AddIcon fontSize="small" style={{ color: 'white', fontWeight: 'bold', fontSize: 25 }} />
          </Fab>
        
      <AddItemPopup open={popupOpen} onClose={() => setPopupOpen(false)} onSave={handleAdd} />

    </div>
  );
}

export default MembershipMgmt;
